import { Flex, Typography } from '@project44/manifest-ds';

import { ChildrenType } from '../../definitions/types/Children';
import CopyButton from './components/CopyButton';
import SeeAllButton from './components/SeeAllButton';
import SeeMore from './components/SeeMore';

import {
  Container,
  Content,
  Footer,
  Header,
  LengthContainer,
  TitleContainer,
} from './styles';

interface CardReferenceProps {
  title: string;
  itemCount?: number;
  children?: ChildrenType;
  extra?: ChildrenType;
  footer?: ChildrenType;
  dataLength?: number;
}

export const CardReference = ({
  children,
  title,
  extra,
  footer,
  dataLength,
}: CardReferenceProps) => (
  <Container data-testid="card-reference">
    <Header data-testid="card-reference-header">
      <Flex justify="between" align="center">
        <TitleContainer>
          <Typography variant="bodyBold">{title}</Typography>
          <LengthContainer>{dataLength}</LengthContainer>
        </TitleContainer>
        {extra}
      </Flex>
    </Header>
    {children && (
      <Content data-testid="card-reference-content">{children}</Content>
    )}
    {footer && <Footer data-testid="card-reference-footer">{footer}</Footer>}
  </Container>
);

CardReference.SeeMore = SeeMore;
CardReference.SeeAllButton = SeeAllButton;
CardReference.CopyButton = CopyButton;
